<template>
  <main>
    <div class="py-4 container-fluid">
      <GridRow>
        <GridCol :size="12">
          <MetaSection :title="'Tracking Status: Update KPI - '+ periode_active?.name">
            <div class="text-right">
              <div class="d-flex flex-row gap-3">
                <!-- <argon-button :outline="true">Kembali</argon-button>
                <argon-button>Kirim</argon-button> -->

                <router-link :to="{ name: 'Tracking Status Detail', params: { periode_id, realization_id, status } }">
                  <button class="btn btn-secondary">
                    Kembali
                  </button>
                </router-link>
              </div>
            </div>
            
            
          </MetaSection>
        </GridCol>
        <GridCol :size="12">
          <!-- <cards title="Form Realisasi KPI" useFooter> -->
            <!-- <template v-slot:footer>
              <div class="text-right">
                <div class="d-flex flex-row-reverse gap-2">
                  <ArgonButton>Lanjutkan</ArgonButton>
                  <ArgonButton :to="{ name: 'Realisasi Target' }" isRouteLink outline>Batalkan</ArgonButton>
                </div>
              </div>
            </template> -->

          <cards title="Form Realisasi KPI">
            <tabbed-pane
              :tabs="tabs"
              :disabled="true"
            >

              <div class="tab-pane fade show active" id="pills-penilaian-kinerja" role="tabpanel"
                aria-labelledby="pills-penilaian-kinerja-tab">
                <FieldsetComponent title="Penilaian Kinerja"
                  description="Pastikan data penilaian kinerja sesuai kontrak kerja dan masukkan nilai realisasi sesuai data yang sebenarnya.">
                  <form-group v-for="(item, index) in list_kpi" :key="index" :label="item.title" :hint="item?.sub_jumlah || item?.sub_jumlah === 0 ? item?.sub_jumlah : sumBobotSubKpi(item?.child || [])">
                    <div class="table-responsive">
                      <table class="table align-middle border border-1 border-light">
                        <thead class="table-light">
                          <tr>
                            <th>Sub KPI</th>
                            <th>Target</th>
                            <th>Sartuan</th>
                            <th>Bobot</th>
                            <th>Realisasi</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item_child, i) in item.child"
                            :key="i"
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <p>{{ item_child?.title || '-' }}</p>
                              <p v-if="this.list_kpi[index].child[i].catatan" class="text-xs"> {{ this.list_kpi[index].child[i].catatan || '' }}</p>
                              <button
                                class="btn btn-outline-secondary btn-xs"
                                data-bs-toggle="modal"
                                data-bs-target="#noteModal"
                                type="button"
                                @click="openNoteModal(true, index, i)"
                              >
                                Berikan Catatan
                              </button>
                            </td>
                            <td>
                              <p>
                                {{
                                  new Intl.NumberFormat('id-ID', {
                                    style: 'currency',
                                    currency: 'IDR',
                                    minimumFractionDigits: 0,
                                  }).format(item_child?.target || '0')
                                }}
                              </p>
                            </td>
                            <td>
                              <p>{{ getSatuan(item_child?.satuan) ?? "-" }}</p>
                            </td>
                            <td>
                              <p>{{ item_child?.bobot ?? "-" }}</p>
                            </td>
                            <td>
                              <form-group>
                                <div class="input-group" v-if="item_child?.satuan">
                                  <span class="input-group-text" v-if="['rupiah'].includes(item_child.satuan.toLowerCase())">
                                    <span v-if="item_child.satuan.toLowerCase() === 'rupiah'">Rp</span>
                                  </span>
                                  <input
                                    type="number"
                                    v-model="this.list_kpi[index].child[i].realisasi"
                                    class="form-control"
                                    min="0"
                                    :max="item_child.satuan.toLowerCase() === 'persen' ? '100' : ''"
                                  >
                                  <span class="input-group-text" v-if="['persen','pcs'].includes(item_child.satuan.toLowerCase())">
                                    <span v-if="item_child.satuan.toLowerCase() === 'persen'">%</span>
                                    <span v-if="item_child.satuan.toLowerCase() === 'pcs'">Pcs</span>
                                  </span>
                                </div>

                                <input
                                  v-else
                                  type="number"
                                  v-model="this.list_kpi[index].child[i].realisasi"
                                  class="form-control"
                                  min="0"
                                />
                              </form-group>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </form-group>

                  <!-- Modal -->
                  <div class="modal fade" id="noteModal" tabindex="-1" aria-labelledby="noteModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md">
                      <form class="modal-content" @submit.prevent="submitNote">
                        <div class="modal-header">
                          <h5 class="modal-title" id="noteModalLabel">Berikan Catatan</h5>
                          <span class="p-1 cursor-pointer" data-bs-dismiss="modal" aria-label="Close" ref="closeModalNote">
                            <font-awesome-icon icon="fa-solid fa-times" />
                          </span>
                        </div>
                        <div class="modal-body">
                          <form-group label="Tulis catatan">
                              <!-- v-model="this.list_kpi[index_kpi].child[index_sub_kpi].catatan" -->
                            <input
                              v-model="edit_catatan"
                              ref="editModalNote"
                              type="text"
                              class="form-control w-100"
                              placeholder="Tulis catatan disini..."
                            >

                          </form-group>
                        </div>
                        <div class="modal-footer">
                          <!-- <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Batalkan</button> -->
                          <button type="submit" class="btn btn-secondary w-100">Simpan</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </FieldsetComponent>
              </div>

              <div class="tab-pane fade show" id="pills-penugasan-khusus" role="tabpanel"
                aria-labelledby="pills-penugasan-khusus-tab">
                <FieldsetComponent title="Penugasan Khusus" description="Masukkan data penugasan sesuai yang diberikan oleh pimpinan atau manajemen di luar jobdesk. Penugasan dapat berupa task karena rangkap jabatan, inovasi, atau kreatifitas.">
                  <form @submit.prevent="addPenugasanKhusus()">
                    <form-group>
                      <input
                        v-model="input_penugasan_khusus"
                        type="text"
                        class="form-control"
                        placeholder="Tulis penugasan khusus"
                        required
                      >
                      <p>
                        <small>
                          Contoh, Mengikuti training dalam setiap bulan
                        </small>
                      </p>
                    </form-group>
                    <!-- <argon-button class="btn btn-outline-secondary"><font-awesome-icon icon="fa-solid fa-plus" /> Tambah</argon-button> -->
                    <button type="submit" class="btn btn-secondary btn-xs">
                      <font-awesome-icon icon="fa-solid fa-plus" /> 
                      Tambah
                    </button>
                  </form>

                  <template v-if="list_penugasan_khusus.length > 0">
                    <hr />
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">Penugasan</th>
                          <th scope="col" style="width: 10px;">Aksi</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in list_penugasan_khusus"
                          :key="index"
                        >
                          <td class="pt-2">{{ item?.name || '-' }}</td>
                          <td class="pt-3" width="10">
                            <button class="btn btn-xs btn-outline-secondary mb-2" @click="deletePenugasanKhusus(index)">Hapus</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </template>
                </FieldsetComponent>
              </div>

              <!-- <div class="tab-pane fade show" id="pills-pengurangan" role="tabpanel"
                aria-labelledby="pills-pengurangan-tab">

                <FieldsetComponent
                  title="Pengurangan"
                  description="Masukkan jumlah sanksi/pengurangan yang diterima dalam satu periode penilaian KPI."
                >
                  <form-group>
                    <div class="table-responsive">
                      <table class="table align-middle border border-1 border-light">
                        <thead class="table-light">
                          <tr>
                            <th>Tingkat Permasalahan</th>
                            <th>Jumlah</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in list_pengurangan" :key="index" class="border border-bottom-1 border-light">
                            <td>{{ item?.tingkat_permasalahan ?? "-" }}</td>
                            <td>
                              <form-group>
                                <input
                                  v-model="this.list_pengurangan[index].jumlah_permasalahan"
                                  type="number"
                                  min="0"
                                  class="form-control"
                                />
                              </form-group>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </form-group>
                </FieldsetComponent>
              </div> -->
            </tabbed-pane>
            
            <hr />

            <div class="mt-4 d-flex justify-content-end gap-4">
              <button type="button" class="btn btn-outline-secondary" v-if="step !== 0" @click="nextStep((step - 1), true)">Kembali</button>
              <button type="button" class="btn btn-secondary" v-if="step < 1" @click="nextStep()">Lanjutkan</button>
              <button type="button" class="btn btn-secondary" v-if="step === 1" @click="submit()">Simpan</button>
            </div>
          </cards>
        </GridCol>
      </GridRow>
    </div>
  </main>
</template>
    
<script>
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
// import EmployeeApi from "@/repository/api/EmployeeApi";
// import Select2 from 'vue3-select2-component';
import FieldsetComponent from "@/components/FieldsetComponent.vue";
import TabbedPane from "@/components/TabbedPane.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
import MetaSection from '@/components/MetaSection.vue';
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
// import InputForm from "@/components/InputForm.vue";

import KpiPeriodeApi from "@/repository/api/KpiPeriodeApi";
import KpiRealisasiApi from "@/repository/api/KpiRealisasiApi";
// import PenguranganApi from "../../../repository/api/PenguranganApi";
import PenilaianKpiApi from "@/repository/api/PenilaianKpiApi";

export default {
  name: "realisasi-target",
  components: {
    FieldsetComponent,
    Cards,
    FormGroup,
    TabbedPane,
    // ArgonButton,
    MetaSection,
    GridRow,
    GridCol,
    // InputForm,
  },
  data() {
    return {
      tabs: {
        // 'Periode Penilaian':true,
        'Penilaian Kinerja':true,
        'Penugasan Khusus':false,
        // 'Pengurangan':false,
        // 'Ringkasan':false
      },
      step: 0,
      employee_id: '', // data form
      periode_active: null,

      list_penilaian_kinerja: [], // -> data from api, note dkk
      list_kpi: [], // data form
      index_kpi: null,
      index_sub_kpi: null,
      edit_catatan: '',

      data_penugasan_khusus: null, // -> data from api, note dkk
      list_penugasan_khusus: [], // data form
      input_penugasan_khusus: '',
      list_penugasan_to_detele: [], // delete api per @

      data_pengurangan: null, // -> data from api, note dkk
      list_pengurangan: [], // data form

      satuan_target: [
        {
          value: 'rupiah',
          label: 'Rupiah'        
        },
        {
          value: 'persen',
          label: 'Persen/Hari/Skala Nilai'        
        },
        {
          value: 'pcs',
          label: 'Pcs'        
        }
      ],
    };
  },
  computed: {
    realization_id() {
      return this.$route.params?.realization_id;
    },
    periode_id() {
      return this.$route.params?.periode_id;
    },
    status() {
      return this.$route.params?.status;
    },
  },
  methods: {
    sumBobotSubKpi(data) {
      data = data.map((item) => Number.parseFloat(item?.bobot || 0));
      data = data.reduce((a, b) => a + b, 0);
      return data;
    },
    async nextStep(step=null, is_back=false) {
      if (step || step === 0) {
        this.step = step;
      } else {
        this.step += 1;
      }
      
      // if (this.step === 1 && !is_back) {
      //   if (this.periode_id === '') {
      //     this.step = 0;
      //     this.$swal({
      //       icon: "warning",
      //       title: 'Periode penilaian perlu dipilih terlebih dahulu!',
      //     });
      //     return;
      //   }

      //   if (this.employee_id === '') {
      //     this.step = 0;
      //     this.$swal({
      //       icon: "warning",
      //       title: 'Data pegawai tidak ditemukan!',
      //     });
      //     return;
      //   }

      //   if (this.list_kpi.length === 0) {
      //     this.$store.state.loading = true;
          
      //     this.$store.state.loading = false;
      //   }
      // }

      if (this.step === 2 && !is_back) {
        if (this.list_penugasan_khusus.length === 0) {
          this.step = 1;
          this.$swal({
            icon: "warning",
            title: 'Penugasan khusus harus diisi!',
          });
          return;
        }
      }
      
      const nav_tab = document.getElementsByClassName('nav-link-tab');
      const tab_pane = document.getElementsByClassName('tab-pane');

      for (let index = 0; index < nav_tab.length; index++) {
        nav_tab[index].classList.remove('active');
      }

      for (let index = 0; index < tab_pane.length; index++) {
        tab_pane[index].classList.remove('active');
      }

      Object.keys(this.tabs).forEach(async (item, index) => {
        if (index === this.step) {
          nav_tab[index].classList.add('active');
          tab_pane[index].classList.add('active');
        }
      });
    },
    openNoteModal(is_open=false, index_kpi=null, index_sub_kpi=null) {

      this.index_kpi = index_kpi;
      this.index_sub_kpi = index_sub_kpi;

      if (is_open) {
        this.edit_catatan = this.list_kpi[this.index_kpi].child[this.index_sub_kpi].catatan;
        setTimeout(() => {
          this.$refs.editModalNote.focus();
        }, 600);
      }
    },

    submitNote() {
      this.list_kpi[this.index_kpi].child[this.index_sub_kpi].catatan = this.edit_catatan;
      this.edit_catatan = '';
      this.$refs.closeModalNote.click()
    },

    addPenugasanKhusus() {
      // this.list_penugasan_khusus.push(this.input_penugasan_khusus);
      this.list_penugasan_khusus.push({
        name: this.input_penugasan_khusus,
      });
      this.input_penugasan_khusus = '';
    },

    deletePenugasanKhusus(index) {
      if (this.list_penugasan_khusus?.[index]?.id) {
        this.list_penugasan_to_detele.push(JSON.parse(JSON.stringify(this.list_penugasan_khusus?.[index])))
        console.log('this.list_penugasan_to_detele', this.list_penugasan_to_detele)
      }

      this.list_penugasan_khusus.splice(index, 1);
    },

    async getData() {
      // await EmployeeApi.get(this.$route.params.id).then((response) => {
      //   this.data = response.data;
      // }).catch((error) => {
      //   this.$swal({
      //     icon: "error",
      //     title: error.response.data.message,
      //   }).then(() => {
      //     this.$router.push({ name: "Dashboard" });
      //   });
      // })
    },
    async getKpiPeriode() {
      await KpiPeriodeApi.get(this.periode_id)
        .then((response) => {
          this.periode_active = response?.data || {};
        })
        .catch((err) => {
          console.log(err)
        });
    },
    // async getMasterPenilaianKinerja() {
    //   await KpiRealisasiApi.getbyparam({
    //     employee: this.employee_id,
    //     periode_id: this.periode_id,
    //   }).then((resp) => {
    //     console.log(resp)

    //     if (resp?.data && resp?.data?.length > 0) {
    //       for (let i = 0; i < resp.data.length; i++) {
    //         const item = resp.data[i];
            
    //         this.list_kpi.push({
    //           title: item.title,
    //           child: item.child.map(v => {
    //             let data = {
    //               kpiaspekpenilaianassignment_id: v.kpiaspekpenilaianassignment_id,
    //               kpisub_id: v.id,
    //               title: v.title,
    //               bobot: v.bobot,
    //               target: v.target,
    //               satuan: v.satuan,
    //               realisasi: 0,
    //               catatan: '',
    //             };

    //             return data;
    //           }),
    //         });
    //       }
    //     }
    //   }).catch((err) => {
    //     console.log(err)
    //   });
    // },

    // async getMasterPengurangan() {
    //   await PenguranganApi.get()
    //     .then((resp) => {
    //       if (resp?.data) {
    //         for (let i = 0; i < resp.data.length; i++) {
    //           const item = resp.data[i];
              
    //           this.list_pengurangan.push({
    //             id: item.id,
    //             tingkat_permasalahan: item.tingkat_permasalahan,
    //             nilai: item.nilai,
    //             jumlah_permasalahan: 0,
    //           })
    //         }
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //     });
    // },

    async getPenilaianKpi() {
      await PenilaianKpiApi.getDetailPenilaianKinerja({
        realization_id: this.realization_id,
      })
        .then((resp) => {
          this.list_penilaian_kinerja = resp?.data;

          // if (resp?.data && resp?.data?.length > 0) {
          if (resp?.data?.realisasi_kinerja?.list_kpi?.length > 0) {
            for (let i = 0; i < resp.data.realisasi_kinerja.list_kpi.length; i++) {
              const item = resp.data.realisasi_kinerja.list_kpi[i];
              
              this.list_kpi.push({
                // title: item.title,
                title: item.kpi,
                sub_jumlah: item.sub_jumlah,
                // child: item.child.map(v => {
                child: item.sub_kpi.map(v => {
                  let data = {
                    kpiaspekpenilaianassignment_id: v.assignment_id,
                    kpisub_id: v.id,
                    // title: v.title,
                    title: v.nama_aspek_kpi,
                    bobot: v.bobot,
                    target: v.target,
                    satuan: v.satuan,
                    realisasi: v.realisasi,
                    catatan: v.catatan,
                  };

                  return data;
                }),
              });
            }

            console.log(this.list_kpi)
          }
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getPenugasanKhusus() {
      await PenilaianKpiApi.getDetailPenugasanKhusus({
        employee_id: this.employee_id,
        realization_id: this.realization_id,
      })
        .then((resp) => {
          this.data_penugasan_khusus = resp?.data;

          if (resp?.data?.penugasan?.length > 0) {
            this.list_penugasan_khusus = resp?.data?.penugasan;
          }
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getPengurangan() {
      await PenilaianKpiApi.getDetailPengurangan({
        employee_id: this.employee_id,
        realization_id: this.realization_id,
      })
        .then((resp) => {
          this.data_pengurangan = resp?.data;

          if (resp?.data?.pengurangan) {
            this.list_pengurangan = resp?.data?.pengurangan;
          }
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async submit() {

      // step 1
      // list_penilaian_kinerja: [], // -> data from api, note dkk
      // list_kpi: [], // data form
      // index_kpi: null,
      // index_sub_kpi: null,
      // edit_catatan: '',
      // console.log('data step 1', this.list_kpi)

      // step 2
      // data_penugasan_khusus: null, // -> data from api, note dkk
      // list_penugasan_khusus: [], // data form
      // input_penugasan_khusus: '',
      // list_penugasan_to_detele: [], // delete api per @
      console.log('data step 2', this.list_penugasan_khusus, this.list_penugasan_to_detele)

      // step 3
      // data_pengurangan: null, // -> data from api, note dkk
      // list_pengurangan: [], // data form
      // console.log('data step 3', this.list_pengurangan)

      this.$swal({
        icon: "info",
        title: "Submit revisi?",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;

          try {

            // step 1
            let realisasi = [];

            this.list_kpi.forEach(item => {
              if (item?.child) {
                item.child.forEach(item_child => {
                  realisasi.push({
                    kpiaspekpenilaianassignment_id: item_child.kpiaspekpenilaianassignment_id,
                    kpisub_id: item_child.kpisub_id,
                    bobot: item_child.bobot,
                    target: item_child.target,
                    realisasi: item_child.realisasi,
                    catatan: item_child.catatan,
                    satuan: item_child.satuan,
                  })
                });
              }
            });
            
            await KpiRealisasiApi.updateRealisasiKinerja({
              employee_id: this.employee_id,
              realization_id: this.realization_id,
              realisasikinerja_id: this.list_penilaian_kinerja.realisasi_kinerja.id,
              realisasi: JSON.stringify(realisasi),
            })
              .then((resp) => {
                console.log('updateRealisasiKinerja()')
                console.log(resp?.data)
              }).catch((error) => {
                console.log(error)
                // this.$swal({
                //   icon: "error",
                //   title: error?.response?.data?.message,
                // });
                throw error;
              });
            
            // step 2
            // add penugasan 
            let list_penugasan_new = JSON.parse(JSON.stringify(this.list_penugasan_khusus)).filter(item => !item?.id)
            console.log(list_penugasan_new)
            
            if (list_penugasan_new.length > 0) {
              for (let i = 0; i < list_penugasan_new.length; i++) {
                const item = list_penugasan_new[i];
  
                await KpiRealisasiApi.addRealisasiPenugasanKhusus({
                  employee_id: this.employee_id,
                  realization_id: this.realization_id,
                  name: item.name,
                })
                  .then((resp) => {
                    console.log('addRealisasiPenugasanKhusus() '+ i)
                    console.log(resp?.data)
                  }).catch((error) => {
                    console.log(error)
                    // this.$swal({
                    //   icon: "error",
                    //   title: error?.response?.data?.message,
                    // });
                    throw error;
                  });
              }
            }

            if (this.list_penugasan_to_detele.length > 0) {
              for (let i = 0; i < this.list_penugasan_to_detele.length; i++) {
                const item = this.list_penugasan_to_detele[i];
  
                await KpiRealisasiApi.deleteRealisasiPenugasanKhusus(item.id)
                  .then((resp) => {
                    console.log('deleteRealisasiPenugasanKhusus() '+ i)
                    console.log(resp?.data)
                  }).catch((error) => {
                    console.log(error)
                    // this.$swal({
                    //   icon: "error",
                    //   title: error?.response?.data?.message,
                    // });
                    throw error;
                  });
              }
            }

            // step 3
            // let pengurangan = JSON.parse(JSON.stringify(this.list_pengurangan));

            // pengurangan = pengurangan.map(item => {
            //   return {
            //     id: item.pengurangan_id,
            //     nilai: item?.nilai || 0,
            //     tingkat_permasalahan: item.tingkat_permasalahan,
            //     jumlah_permasalahan: item.jumlah_permasalahan,
            //   }
            // });
            
            // await KpiRealisasiApi.addRealisasiPengurangan({
            //   employee_id: this.employee_id,
            //   realization_id: this.realization_id,
            //   pengurangan: JSON.stringify(pengurangan),
            // })
            //   .then((resp) => {
            //     // console.log('addRealisasiPengurangan()')
            //     console.log(resp?.data)
            //   }).catch((error) => {
            //     // console.log(error)
            //     // this.$swal({
            //     //   icon: "error",
            //     //   title: error?.response?.data?.message,
            //     // });
            //     throw error;
            //   });
            
            // final, update status
            await KpiRealisasiApi.updateStatusKpi({
              realization_id: this.realization_id,
            })
              .then((resp) => {
                // console.log('udateStatusKpi()')
                console.log(resp?.data)
              }).catch((error) => {
                // console.log(error)
                // this.$swal({
                //   icon: "error",
                //   title: error?.response?.data?.message,
                // });
                throw error;
              });
            

            // success -> reset all data
            // end reset data

            this.$store.state.loading = false;

            this.$swal({
              icon: "success",
              title: 'Berhasil mengubah data KPI.',
            });

            this.$router.push({ name: 'Tracking Status' });
            
          } catch (error) {
            console.log(error)
            // this.$store.state.loading = false;
            this.$swal({
              icon: "error",
              title: error?.response?.data?.message || 'Something wrong, please try again.',
            });
          }
        }
      });
    },
    getSatuan(satuan) {
      let result = null
      try {
        result = this.satuan_target.find(({ value }) => value === satuan);
        result = result.label
      } catch (error) {
        result = satuan
      }
      return result
    }
  },
  async mounted() {
    this.$store.state.loading = true;
    await this.getSessionUser();
    this.employee_id = this.$store.state?.sessionUser?.employee?.id || '';

    await this.getKpiPeriode();
    // await this.getMasterPenilaianKinerja();
    // await this.getMasterPengurangan();

    this.getPenilaianKpi();
    this.getPenugasanKhusus();
    this.getPengurangan();
    this.$store.state.loading = false;
  },
};
</script>
    